import { usePilotAccess } from "@/components/pilot/pilot-access-context";
import { ReactNode } from "react";
import { useAuth } from "@/hooks";
import {
  ModuleType,
  PermissionContext,
  PermissionContextType,
  PermissionType,
} from "@/contexts";

type GrantedModule = {
  hasPermission?: boolean;
  permissions?: Array<{ name: string; hasPermission: boolean }>;
};

export const PermissionProvider = ({ children }: { children: ReactNode }) => {
  const { user: currentUser } = useAuth();
  const { readOnly } = usePilotAccess();
  // SEC-GATES-02: a user with no role (or a role without the grouped
  // permissions) holds no grant; it must not crash the shell.
  const modules = (currentUser?.roles?.[0]?.permissions ?? {}) as Partial<Record<ModuleType, GrantedModule>>;

  const hasPermission = (moduleName: ModuleType): boolean =>
    modules[moduleName]?.hasPermission === true;

  const checkPermission = (
    moduleName: ModuleType,
    name: PermissionType
  ): boolean => {
    if (readOnly && !name.startsWith("view ")) return false;
    return (
      modules[moduleName]?.permissions?.some(
        (permission) => permission.name === name && permission.hasPermission
      ) ?? false
    );
  };

  const contextValue: PermissionContextType = {
    // userPermissions,
    hasPermission,
    // permissions: permissionsData?.permissions || [],
    checkPermission,
  };

  return (
    <PermissionContext.Provider value={contextValue}>
      {children}
    </PermissionContext.Provider>
  );
};
